export default __webpack_public_path__ + "ed6124cdb5f5bf46619a612e335be86a.svg";